import * as React from 'react';
import styled from 'styled-components';
import Logs from 'pages/DelegatedSearchPage';

import { Modal } from 'security-app/components/common';

const LogsContainer = styled.div`
  footer,
  #main-row > div:first-of-type,
  .react-grid-item:first-child {
    display: none;
  }
  .react-grid-item {
    top: 0px !important;
  }
  .react-grid-layout {
    height: 630px !important;
  }
`;

type LogsModalProps = {
  show: boolean;
  onCancel: () => void;
};

const LogsModal = ({ show, onCancel }: LogsModalProps) => (
  <Modal show={show} title="Add Logs" onClose={onCancel} maxWidth="1300px" closeOnBackdrop>
    <LogsContainer>
      <Logs />
    </LogsContainer>
  </Modal>
);

export default LogsModal;
